import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import PasswordReset from './PasswordReset';
import PasswordResetErrorResponse from './PasswordResetErrorResponse';

export interface Result {
	passwordReset: PasswordReset;
}

export default function findPasswordReset(client: ApiClient, token: string, userId: string): Promise<Result> {
	const url = parseTemplate('authentication/password/reset/{token}{?user}');

	return client
		.unauthenticatedFetch(url.expand({ token, user: userId }))
		.then((response) => response.json())
		.then((response) => ({
			passwordReset: new PasswordReset(response.passwordReset.active),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, PasswordResetErrorResponse));
}
